// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r1-1";
export var stateContainer = "_r1-0";